// =============================================================================
//  Copyright : 2023 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : admin components
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import {Sel, Actions} from 'uix/registries'
import {XMenu} from 'uix/components'
import log from 'uix/logging'
import {useApi, useRouter} from 'uix/hooks'
// ---Globals

export const NodeSwitchItem = ({node, onNodeChange}) => {
  let {request, go} = useRouter()
  let {data} = useApi('node/list')
  let nodes = data?.nodes || []
  nodes = [{name: 'host'}, ...nodes]

  return (
    <XMenu.Dropdown
      options={nodes.map(({name}) => ({
        value: name,
        key: name,
        text: name,
      }))}
      value={node || request.node || 'host'}
      onValueChange={v =>
        onNodeChange ? onNodeChange(v) : go({updateQuery: {node: name == 'host' ? null : v}})
      }
      search
      title="Switch node"
    />
  )
}
